import {API} from '@/util/API';

const getAssetsPrice = async (
  assets: string[]
): Promise<Record<string, {symbol: string; price: string}>> => {
  if (!assets.length) {
    return {};
  }

  return API.get<null, Record<string, {symbol: string; price: string}>>(
    `/pricing/quotes?queries=${assets.join(',')}`
  );
};

export interface HistoryEntry {
  price: string;
  timestamp: number;
}

export interface HistoryItem {
  symbol: string;
  quote: string;
  from: number;
  to: number;
  history: HistoryEntry[];
  interval: 'hourly' | 'daily';
}

export interface ErrorState {
  error: true;
  stack: string;
}

export type GetPriceHistoriesResponse = Record<
  string,
  HistoryItem | ErrorState
>;

const getPriceHistories = async (
  assets: string[],
  from: number,
  interval: 'daily' | 'hourly' = 'hourly'
): Promise<GetPriceHistoriesResponse> => {
  if (!assets.length) {
    return {};
  }

  return API.get<null, GetPriceHistoriesResponse>(
    `/pricing/price-history?queries=${assets.join(
      ','
    )}&from=${from}&interval=${interval}`
  );
};

export const pricingApi = {getAssetsPrice, getPriceHistories};
